import React from 'react'

import { ArrowLeft, ArrowRight } from '../common/Icons'

const CustomerSliderHeading = ({ icon, heading, subheading, index }) => {
  return (
    <div className="container mx-auto px-6 xl:max-w-[1200px] xl:px-0">
      <img
        className="w-10 sm:w-[64px]"
        src={icon}
        alt="people"
      />
      <div className="flex items-end justify-between gap-10 pt-6 md:items-center">
        <h3 className="text-[28px] font-semibold leading-[120%] tracking-[-1.2px] text-blue sm:text-[44px]">
          {heading}{' '}
          <span className="traking-[-0.96px] block text-xl font-semibold leading-[133%] text-night-black sm:text-2xl md:inline-block">
            {subheading}
          </span>
        </h3>
        <div className="icon flex gap-3">
          <span
            className={`group cursor-pointer people-swiper-button-prev-${index}`}
          >
            <ArrowLeft />
          </span>
          <span
            className={`group cursor-pointer people-swiper-button-next-${index}`}
          >
            <ArrowRight />
          </span>
        </div>
      </div>
    </div>
  )
}

export default CustomerSliderHeading
